export default __webpack_public_path__ + "static/media/hand_default.a6d4a4b8.png";